import { render, staticRenderFns } from "./ai-answer-button.vue?vue&type=template&id=3386ead1&scoped=true"
import script from "./ai-answer-button.vue?vue&type=script&lang=js"
export * from "./ai-answer-button.vue?vue&type=script&lang=js"
import style0 from "./ai-answer-button.vue?vue&type=style&index=0&id=3386ead1&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3386ead1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3386ead1')) {
      api.createRecord('3386ead1', component.options)
    } else {
      api.reload('3386ead1', component.options)
    }
    module.hot.accept("./ai-answer-button.vue?vue&type=template&id=3386ead1&scoped=true", function () {
      api.rerender('3386ead1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taxLaw/home/chat/ai-answer-button.vue"
export default component.exports